<template>
    <div style="display:flex;margin-inline-start: 12px;margin-top: 12px;" class="capture-subclip-thumbnail" @click="$emit('capturedSubclipClicked',parentData)">
        <div style="width:345px;" :style="isAudioFile ? 'width:unset !important;':''"> 
            <!-- <div id="output" style="display: inline-block; top: 4px; position: relative ;border: dotted 1px #ccc; padding: 2px;width:100%" v-html="canvas"></div> -->
          <img v-show="makinmarkout.capture == false" @error="replaceByDefaultImage" :style="isAudioFile ? 'padding: 19px; height: 107px; width: 190px;': ''" style="height: 100%; max-width: 280px; overflow: hidden; max-height: 157.50px;object-fit: contain;
    width: 100%;border: 1px solid #4a4a4a; border-radius: 5px;" draggable="false" :src="getProxyConvertedURL(imageSrc)" />
          <canvas v-show="makinmarkout.capture" id="markinmarkoutcanvas" style="width:280px;max-height: 157.50px;max-width: 280px;height:157.50px;"></canvas>
        </div>
        <div  class="w-100" style="display: flex !important;align-items: flex-start;">
            <ul class="p-0 m-0" style="margin-inline-start:0px;">
                <li>
                    <!-- <div class="key-style">Subclip</div> -->
                    <div v-if="parentData.markers" class="value-style thumbnail-view-duration-label" style="overflow-wrap:anywhere;text-align:start">
                      <div style="color: #319aab;margin-top: 1px;">
                        <template v-if="parentData.markers.start == parentData.markers.end">
                            {{getDurationInSecondsForMarkers(parentData.markers.start)}}
                        </template>
                        <template v-else>
                           {{getDurationInSecondsForMarkers(parentData.markers.start) + ' - ' + getDurationInSecondsForMarkers(parentData.markers.end)}}
                        </template>
                      </div>
                   </div>
                    <!-- <div class="value-style slug-name" :style="stylesFromParent.slugFontSize">{{subclipsData.slug_name}}</div> -->
                </li>
                <li v-if="parentData.modified_datetime">
                    <!-- <div class="key-style">Description</div> -->
                    <div class="value-style" style="font-size: 12px;">
                        {{getDateAndTimeInConfiguredFormat(parentData.modified_datetime)}}
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js";
import {mapMutations} from 'vuex';
export default {
   name:'MarkinMarkoutThumbnail',
   props:['makinmarkout',"parentData","fileInfo","videoComponent","capturedINthumbnail"],
   data(){
       return {
            imageSrc: Utils.getNoThumbnailImg(),
            capturedIn: Utils.getNoThumbnailImg(),
       }
   },
   methods:{
        getImageThumbnail(){
            return this.imageSrc;
        },
        setAudioSvgCanvas(src){
            this.imageSrc = src;
        },
        async getCapturedImage(){
           return new Promise((resolve)=>{
             this.captureCanvas((img) => {
                 resolve(img);
              });
           });
        },

        getImageWidthandHeightBasedOnAspectRatio(){
            const video = this.videoComponent.$el.querySelector('video');
            const videoCanvas = document.getElementById("markinmarkoutcanvas");

            if (!video || video.readyState < 2) {
                // HAVE_CURRENT_DATA not reached yet — nothing to draw
                console.warn('Video frame not available yet');
                return { offsetX: 0, offsetY: 0, drawWidth: 0, drawHeight: 0 };
            }

            const videoWidth  = video.videoWidth;
            const videoHeight = video.videoHeight;

            // Scale to the canvas's current width, keep the video's own aspect ratio
            const targetWidth = videoCanvas.width;          // or hardcode 320 like the capture flow
            const scale       = targetWidth / videoWidth;

            const drawWidth  = targetWidth;
            const drawHeight = Math.round(videoHeight * scale);

            // Resize the canvas so the frame fills it exactly — no letterbox bars
            videoCanvas.height = drawHeight;

            return { offsetX: 0, offsetY: 0, drawWidth, drawHeight };
        },
        async replaceByDefaultImage(e){
            e.target.onerror = null;
            let img = await this.getCapturedImage();
            console.log(`[img img]`,img);
            if(img){
               e.target.src = img;//Utils.getNoThumbnailImg();
            }else{
                e.target.src = Utils.getNoThumbnailImg();
            }
        },

        captureCanvas(callback){
            let base64image = '';
            try{
                const video = this.videoComponent.$el.querySelector('video');
                let videoCanvas = document.getElementById("markinmarkoutcanvas");
                let coordinates = this.getImageWidthandHeightBasedOnAspectRatio();
                console.log(`[coordinates coordinates][captureCanvas]`,coordinates);
                videoCanvas.getContext("2d").drawImage(video, coordinates.offsetX, coordinates.offsetY, coordinates.drawWidth, coordinates.drawHeight);
                base64image = videoCanvas.toDataURL();
                this.capturedIn = base64image;
                if(callback && typeof callback == 'function'){
                    return callback(base64image);
                }
            }catch(e){
                console.log(e);
                return callback(null);
            }
            return callback(null);
        },

        displayThumbnail(donotEmitEvent = false, isCaptureOnlyIN = false){
            let base64image = '';
            try{
                const video = this.videoComponent.$el.querySelector('video');
                let videoCanvas = document.getElementById("markinmarkoutcanvas");
                let coordinates = this.getImageWidthandHeightBasedOnAspectRatio();
                console.log(`[displayThumbnail][coordinate]`,coordinates);
                videoCanvas.getContext("2d").drawImage(video, coordinates.offsetX, coordinates.offsetY, coordinates.drawWidth, coordinates.drawHeight);
                base64image = videoCanvas.toDataURL();
            }catch(e){
                console.log(e);
            }

            this.imageSrc = base64image;
            if(isCaptureOnlyIN){
                this.capturedIn = base64image;
            }
            //console.log('base64image base64image',base64image);
            this.makinmarkout.capture = false;
            if(!donotEmitEvent)
              this.$emit('capturedCanvas',base64image);

            return base64image;
       },

       setINThumbnail(inThumbnail){
         if(inThumbnail){
          this.imageSrc = inThumbnail;
         }else{
            this.imageSrc = this.capturedIn;
         }
       },

       setThumbnailImage(){
           console.log(`[setThumbnailImage][setThumbnailImage]`,Utils.getFileMediaType(this.fileInfo));
           if(Utils.getFileMediaType(this.fileInfo) == 'audio'){
              this.imageSrc = Utils.getAudioWaveformSvg();
              return;
           }
           if(this.makinmarkout.thumbnail){
               this.imageSrc = this.makinmarkout.thumbnail;
           }
       },
        getDurationInSecondsForMarkers(duration){
            let regex = new RegExp(":")
            if(regex.test(duration)){
                return duration;
            }
            if(Utils.getFileMediaType(this.fileInfo) == 'audio'){
                return Utils.getExactDuationInSeconds(duration/1000);
            }
            let frameRate = 25;
            if(this.fileInfo && Object.prototype.hasOwnProperty.call(this.fileInfo,'frame_rate')){
                frameRate = this.fileInfo.frame_rate;
            }
            return Utils.getExactDuationInSeconds(duration/1000,frameRate,'.');
        },
        handleSubclipsNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
            let subclip_info = notification.message;
            if(notification.message_type == NotifierConstants.assetCreatedNotification){
                if(this.parentData._id == subclip_info.asset_id){
                     //update thumbnail
                     this.imageSrc = Utils.convertToLoginIPDomainName(subclip_info.markers.frame_thumbnail_uri);
                  }
                }
            }
        },
        registerforWebsocketNotifications(){
          this.addWSEventListener({
                eventname:[NotifierConstants.assetCreatedNotification],
                callback:this.handleSubclipsNotification,
                parent:"markinmarkoutthumbnail"})
        },
        unRegisterforWebsocketNotifications(){
        this.removeWSEventListener({
                eventname:[NotifierConstants.assetCreatedNotification],
                callback:this.handleSubclipsNotification,
                parent:"markinmarkoutthumbnail"})
        },
       ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
   },
  watch:{
       immediate:true,
    //    deep:true,
       'makinmarkout.dur':function(newval){
           console.log('this.displayThumbnail();',newval);
           //this.$nextTick(()=>{
                if(this.makinmarkout.capture){
                    this.displayThumbnail();
                }
                this.setThumbnailImage();
          // });
       }
   },

   mounted(){
    /*
    if(this.makinmarkout.capture)
       this.displayThumbnail();

       this.setThumbnailImage();
     */
       this.makinmarkout.capture = false;
       this.setThumbnailImage();
       this.registerforWebsocketNotifications();
   },

   beforeDestroy(){
       console.log('canvas destroyed');
       this.unRegisterforWebsocketNotifications();
       try{
         document.removeChild(document.getElementById('markinmarkoutcanvas'));
       }catch(e){console.log(e)}
   },
   created(){
       console.log(`[image loaded................]`);
       this.imageSrc = this.capturedINthumbnail;
   },

   computed:{
     isAudioFile(){
         if(this.fileInfo){
            return Utils.getFileMediaType(this.fileInfo) == 'audio';
         }
        return false;
     }
   },
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #141414;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$danger-color: #dc3545 !important;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$secondary-border-color: 1px solid #3a3a3a;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #bbb;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem 10px;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$breadcrumb-background:#181818;
$mutliselect-tag-bg-color:#0a0a0a;
$mutliselect-all-tags-bg-color:#161616;
$multiselect-option-highlight-bg-color:#242424;
$multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
$learn-about-text-color:#e8912d;
$close-icon-bg-on-hover:#3a3a3a;
$svg-color:#9e9e9e;
$tags-background-color:#272727;
$tags-border-color:#363636;
$multiselect-tag-border-color:#292929;
$metadata-border-color:#303030;
$metadata-border-color-on-hover: #5a5a5a;
$metadata-field-bg-color: #1d1d1d;

ul{
    list-style-type: none;
    padding: 0px;
    margin:0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:3px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: start;
        }
        .value-style{
            color: #c7c7c7;
            width: auto;
            text-align: start;
            margin-inline-start: 11px;
        }
    }
}

.thumbnail-view-duration-label{
    font-size: 14px;
    background: #01868c;
    padding: 1px 5px;
    justify-content: start;
    display: flex;
    border-radius: 3px;
    color: #000 !important;
    div{
        color: #eee !important;
    }
  }

  .custom-metadata-rows{
    padding:2px;
  }

  .capture-subclip-thumbnail:hover{
       background: #252728;
  }

  .capture-subclip-thumbnail:hover img{
       filter: brightness(1.0333);
  }

</style>